import React from "react";
import { PageButtonLink } from "../../../_metronic/layout/core";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

export const PageToolbarButton: React.FC<PageButtonLink> = (props) => {
    if (props.renderComponent) {
        return <>{React.createElement(props.renderComponent, props.renderComponentProps || {})}</>;
    }

    const { path, title, cssExtraClass, cssClass, onClick } = props;

    const className = `${cssClass || "btn btn-sm"} ${cssExtraClass || "btn-primary"}`;

    if (path === "#") {
        return (
            <Button className={className} onClick={onClick}>
                {title}
            </Button>
        );
    }

    return (
        <Link to={path} className={className} onClick={onClick}>
            {title}
        </Link>
    );
};
